define('app/routers/global_router',['app/setup', 'app/lib/lockr'], function(takhfifan) {
  var GlobalRoute = Backbone.Router.extend({
    routes: {
      "rls/:reset": "resetSession",
      "": "resetRoute"
    },

    resetSession: function (reset) {
      if(reset && Lockr){
        Lockr.set('reset', true);
      }
    },

    resetRoute: function(){
      takhfifan.eventHub.trigger('route:reset');
    }


  });

  takhfifan.GlobalRoute =  new GlobalRoute;
});

